var bootstrapTooltip = function () {
    $('[data-toggle="tooltip"]').tooltip();
};

var bootstrapPopover = function () {
    $('[data-toggle="popover"]').popover();
};

var bootstrapTab = function () {
    // Javascript to enable link to tab
    var url = document.location.toString();
    if (url.match('#')) {
        $('.register-nav a[href="#' + url.split('#')[1] + '"]').tab('show');
    }

    // Change hash for page-reload
    $('.register-nav a').on('shown.bs.tab', function (e) {
        window.location.hash = e.target.hash;
    })
};


jQuery(document).ready(function($){
    bootstrapTooltip();
    bootstrapPopover();
    bootstrapTab();
});

